<template>
  <div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
